import React from 'react'

export const SuccessIcon = () => {
  return (
    <div className='box-content w-20 h-20 p-2 rounded-full bg-green-500 flex justify-center items-center'>
      <div className='box-content h-12 w-12 p-2 rounded-full bg-green-800 flex justify-center items-center'>
        <svg
          width='40'
          height='30'
          viewBox='0 0 40 30'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M39.6419 3.21314L12.9285 29.9243L0.357422 17.3576L3.49075 14.2243L12.9285 23.6376L36.5063 0.0820312L39.6396 3.21537L39.6419 3.21314Z'
            fill='white'
          />
        </svg>
      </div>
    </div>
  )
}
